import * as React from 'react';
import makeIcon from './make_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var roundFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3ZM11.9999 14C8.12897 14 4.90118 16.7487 4.1599 20.4005C4.13005 20.5476 4.16782 20.7003 4.26278 20.8164C4.35774 20.9326 4.49986 21 4.64991 21H19.3499C19.4999 21 19.642 20.9326 19.737 20.8164C19.8319 20.7003 19.8697 20.5476 19.8399 20.4005C19.0986 16.7487 15.8708 14 11.9999 14Z"
});
var roundLined = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8ZM12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3ZM5.14025 20.5995C5.78879 17.4045 8.61426 15 12.0002 15C15.3862 15 18.2116 17.4045 18.8602 20.5995C18.9151 20.8701 19.179 21.0449 19.4497 20.99C19.7203 20.9351 19.8951 20.6712 19.8402 20.4005C19.0989 16.7487 15.8711 14 12.0002 14C8.1293 14 4.90151 16.7487 4.16024 20.4005C4.1053 20.6712 4.28015 20.9351 4.55078 20.99C4.8214 21.0449 5.08532 20.8701 5.14025 20.5995Z"
});
var sharpFilled = ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3ZM12.0002 14C8.12932 14 4.90153 16.7487 4.16026 20.4005L4.03857 21H19.9619L19.8402 20.4005C19.0989 16.7487 15.8712 14 12.0002 14Z"
});
var sharpLined = ___EmotionJSX(React.Fragment, null, ___EmotionJSX("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3C9.23858 3 7 5.23858 7 8C7 10.7614 9.23858 13 12 13C14.7614 13 17 10.7614 17 8C17 5.23858 14.7614 3 12 3ZM8 8C8 5.79086 9.79086 4 12 4C14.2091 4 16 5.79086 16 8C16 10.2091 14.2091 12 12 12C9.79086 12 8 10.2091 8 8Z"
}), ___EmotionJSX("path", {
  d: "M12.0001 15C8.47364 15 5.55623 17.6077 5.071 21H4.06201C4.5541 17.0537 7.92049 14 12.0001 14C16.0797 14 19.4461 17.0537 19.9382 21H18.9292C18.444 17.6077 15.5266 15 12.0001 15Z"
}));
var IconPerson = makeIcon('IconPerson', 'Person', false, {
  roundFilled,
  roundLined,
  sharpFilled,
  sharpLined
});
export default IconPerson;